import { z } from 'zod'
import { CartItem } from './CartItem'

export const Cart = z.object({
  id: z.string().uuid(),
  items: z.array(z.object(CartItem.shape))
})

export type Cart = z.infer<typeof Cart>

/**
 * What the final pre-payment cart submission sends.
 *
 * The consent declarations are deliberately not part of `Cart`: they are sent
 * once, on the last POST before payment, and the response does not echo them.
 * Modelling them here keeps them out of the cart store, which is re-POSTed on
 * every mutation — sending them on intermediate updates would record a consent
 * the customer had not yet given.
 */
export const CartCheckoutSubmission = Cart.extend({
  terms_accepted: z.boolean().optional(),
  withdrawal_consent: z.boolean().optional(),
  /** Revision of the legal text the customer was shown, e.g. "2026-07-25". */
  consent_version: z.string().optional()
})

export type CartCheckoutSubmission = z.infer<typeof CartCheckoutSubmission>
